import { State, UserState } from '../types'
import Cookies from 'js-cookie'
import { Token } from '@/utils/constants'
import { Module } from 'vuex'
import { GetterTree } from 'vuex'
import { ActionTree } from 'vuex'
import { MutationTree } from 'vuex'
import { login, logout, trialLogin } from '@/api/user'
import {
    getCookieValue,
    getValueByKey,
    setCookieValue,
    toResponseData
} from '@/utils'
import { LoginParam } from '@/datamodel/urlparams/LoginParams'
import { ResponseData } from '@/datamodel/response-data'
import { LogoutParams } from '@/datamodel/urlparams/LogoutParams'

import { MemberLimit, RedPacket, UserInfo, UserSessions } from 'vue'

export enum UserMutation {
    SET_USER_ID = 'SET_USER_ID',
    SET_SESSION = 'SET_SESSION',
    DELETE_SESSION = 'DELETE_SESSION',
    SET_BET_COIN = 'SET_BET_COIN',
    SET_USER_INFO = 'SET_USER_INFO',
    SET_USER_INFO_LIMITS = 'SET_USER_INFO_LIMITS',
    SET_RED_PACKETS = 'SET_RED_PACKETS',
    OFF_RED_PACKETS = 'OFF_RED_PACKETS'
}

const state: UserState = {
    sessionId: getCookieValue(Token.SESSION)?.b64decode() || undefined,
    // Cookies.get(Token.SESSION)?.b64decode(),
    betCoin: parseInt(getCookieValue(Token.BET_COIN) || '0'),
    //parseInt(Cookies.get(Token.BET_COIN)?.b64decode() || '0') ||
    userId: getCookieValue(Token.USERNAME)?.b64decode() || undefined,
    // Cookies.get(Token.USERNAME)?.b64decode(),
    token: getCookieValue(Token.SESSION)?.b64decode() || undefined,
    memberId: parseFloat(getCookieValue(Token.MEMEBER_ID) || '-1'),
    userInfo: getCookieValue(Token.USER_INFO)
        ?.b64decode()
        .toObject<UserInfo>(),
    userLimits: getCookieValue(Token.LIMITS)?.toObject<MemberLimit[]>() || [],
    redpackets:
        getCookieValue(Token.RED_PACKETS)?.toObject<RedPacket[]>() || [],
    showRedPackets: parseInt(getCookieValue(Token.SHOW_RED_PACKETS) || '0')
}

const mutations: MutationTree<UserState> = {
    [UserMutation.SET_USER_ID](state, userId: string) {
        if (userId !== undefined || userId !== '') {
            setCookieValue(Token.USERNAME, userId.b64encode())
        }
        state.userId = userId
    },
    [UserMutation.SET_SESSION](state, payload: UserSessions) {
        state.token = payload.token
        state.userId = payload.username

        state.memberId = payload.memberId

        setCookieValue(Token.SESSION, payload.token.b64encode())
        setCookieValue(Token.USERNAME, payload.username.b64encode())

        if (!Number.isNaN(payload.point)) {
            state.betCoin = payload.point
            setCookieValue(Token.BET_COIN, String(state.betCoin))
        }

        setCookieValue(Token.MEMEBER_ID, String(payload.memberId))
    },
    [UserMutation.SET_BET_COIN](state, betCoin: number) {
        if (!Number.isNaN(betCoin)) {
            setCookieValue(Token.BET_COIN, String(betCoin))
            state.betCoin = betCoin
        }
    },
    [UserMutation.SET_USER_INFO](state, payload: UserInfo) {
        state.userInfo = payload
        setCookieValue(Token.USER_INFO, JSON.stringify(payload).b64encode())
    },
    [UserMutation.SET_USER_INFO_LIMITS](state, payload: MemberLimit[]) {
        state.userLimits = payload
        setCookieValue(Token.LIMITS, JSON.stringify(payload))
    },
    [UserMutation.SET_RED_PACKETS](state, payload: RedPacket[]) {
        state.redpackets = payload
        setCookieValue(Token.RED_PACKETS, JSON.stringify(payload))
    },
    [UserMutation.OFF_RED_PACKETS](state, payload: boolean) {
        const num = payload ? 0 : 1
        state.showRedPackets = num
        setCookieValue(Token.SHOW_RED_PACKETS, String(num))
    }
}

const actions: ActionTree<UserState, State> = {
    authenticateUser({ commit }, model: LoginParam): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            login(model)
                .then(response => {
                    // check if there is a error
                    if (response.data.includes('err=')) {
                        const errorCode = getValueByKey(response.data, 'err')
                        let errorMessage = ''
                        if (errorCode === '-1') {
                            errorMessage = '参数传递错误'
                        } else if (errorCode === '-2') {
                            errorMessage = '用户名或密码输入错误'
                            // '用户或密码错误'
                        } else if (errorCode === '-3') {
                            errorMessage = '账号或上级代理被锁定'
                        } else if (errorCode === '0') {
                            errorMessage = '未知错误'
                        } else {
                            // -4
                            errorMessage = '账号已经登录，请稍后尝试'
                        }
                        reject(errorMessage)
                    } else {
                        resolve(response.data)
                    }
                })
                .catch(() => {
                    reject('网络错误')
                })
        })
    },
    trialoLogin(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            trialLogin()
                .then(response => {
                    if (response.data.includes('err=')) {
                        const errorCode = getValueByKey(response.data, 'err')
                        let errorMessage = ''
                        if (errorCode === '-1') {
                            errorMessage = '参数传递错误'
                        } else if (errorCode === '-2') {
                            errorMessage = '用户名或密码或余额输入错误'
                            // '用户或密码错误'
                        } else if (errorCode === '-3') {
                            errorMessage = '账号或上级代理被锁定'
                        } else if (errorCode === '0') {
                            errorMessage = '未知错误'
                        } else {
                            // -4
                            errorMessage = '账号已经登录，请稍后尝试'
                        }
                        reject(errorMessage)
                    } else {
                        resolve(response.data)
                    }
                })
                .catch(() => {
                    reject('网络错误')
                })
        })
    },
    destroySession({ commit }): void {
        commit(UserMutation.DELETE_SESSION)
    },
    setBetCoin({ commit }, betCoin: number): void {
        commit(UserMutation.SET_BET_COIN, betCoin)
    },
    createSession({ commit }, session: SessionModel): void {
        commit(UserMutation.SET_USER_ID, session.uid)
        commit(UserMutation.SET_SESSION, session.sid)
    },
    logOut({ commit }, userId: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            logout(new LogoutParams(userId))
                .then(() => {
                    commit(UserMutation.DELETE_SESSION)
                    resolve()
                })
                .catch(() => {
                    reject()
                })
        })
    }
}

const getters: GetterTree<UserState, State> = {
    token(state): string | undefined {
        return state.token
    },
    userId(state): string | undefined {
        return state.userId
    },
    betCoin(state): number {
        return state.betCoin
    },
    userLimits: s => s.userLimits,
    memberId: s => s.memberId,
    userInfo: s => s.userInfo,
    redpackets: s => s.redpackets,
    showRedPackets: s => s.showRedPackets === 0
}

export const user: Module<UserState, State> = {
    state,
    mutations,
    actions,
    getters
}
